import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import BlankSlateImage from "../img/BlankSlateImage.svg";

const NoItem = () => {
  const { t } = useTranslation()
  return (
    <Box>
      <img alt={t('common.noItem')} src={BlankSlateImage} />
      <Typography variant="body2" color="text.disabled" align="center">{t('common.noItem')}</Typography>
    </Box>
  );
};

export default NoItem;